import { __awaiter } from "tslib";
import { get } from 'svelte/store';
import { Backend } from './backend';
import { Container } from './container';
import { AppState } from '../etc/stores';
import { StatefulService } from './stateful-service';
import flags from '../etc/flagKeys';
import { AUTH_STORAGE_FLAGS, SessionManager } from './session-manager';
export class CustomerImport extends StatefulService {
    constructor() {
        super(...arguments);
        this.backend = this.ctx.get(Backend);
        this.session = this.ctx.get(SessionManager);
    }
    loadState() {
        return this.loadCustomerImportState();
    }
    checkCampaignStatus(campaignId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.backend.getCustomerImportCampaignByLinkId(campaignId);
            }
            catch (err) {
                return {};
            }
        });
    }
    customerImportRedeem() {
        return __awaiter(this, void 0, void 0, function* () {
            const { customerImportCampaign, website: { authFlow } } = get(AppState);
            if (authFlow !== 'customer-import')
                return;
            if (customerImportCampaign.alreadyClaimedStatus)
                return {
                    redeemStatus: customerImportCampaign.alreadyClaimedStatus
                };
            const redeemPayload = {
                providerName: this.provider,
                campaignId: customerImportCampaign.id ||
                    this.session.get(AUTH_STORAGE_FLAGS.customerImport)
            };
            const response = yield this.backend.customerImportRedeem(redeemPayload);
            AppState.update(state => (Object.assign(Object.assign({}, state), { customerImportCampaign: Object.assign(Object.assign({}, state.customerImportCampaign), { alreadyClaimedStatus: response.redeemStatus }) })));
            return response;
        });
    }
    loadCustomerImportState() {
        return __awaiter(this, void 0, void 0, function* () {
            const { featureFlags } = get(AppState);
            if (!featureFlags.includes(flags.CUSTOMER_IMPORT_WIDGET))
                return;
            const urlParams = new URLSearchParams(location.search);
            const savedCampaignId = this.session.get(AUTH_STORAGE_FLAGS.customerImport);
            if ((!urlParams.has('twism-campaign') || !urlParams.has('twism-linkId')) &&
                !savedCampaignId)
                return;
            const campaignId = savedCampaignId || urlParams.get('twism-linkId');
            const customerImportCampaign = yield this.checkCampaignStatus(campaignId);
            if ((customerImportCampaign === null || customerImportCampaign === void 0 ? void 0 : customerImportCampaign.status) === 'active') {
                AppState.update(state => (Object.assign(Object.assign({}, state), { customerImportCampaign: Object.assign(Object.assign({}, state.customerImportCampaign), customerImportCampaign) })));
            }
        });
    }
}
Container.add(CustomerImport);
